import React from 'react';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import Menu from 'material-ui/svg-icons/navigation/menu';
import {white} from 'material-ui/styles/colors';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import TopMenuControl from 'containers/layout/TopMenuControl';

/**
 * theme  styles - material admin
 */
import style from './styles/headerStyles';

/**
 * action per logout
 */
import { logOut } from 'actions/userActions';

class Header extends React.Component {
  constructor(props){
    super(props);
    this.handleLogOut = this.handleLogOut.bind(this);
  }

  handleLogOut(e){
    e.preventDefault()
    this.props.logOut();
  }

  render() {
    const {styles, handleChangeRequestNavDrawer, applicationName} = this.props;

    return (
        <div>
            <AppBar
              style={{...styles, ...style.appBar}}
              title={applicationName}
              iconElementLeft={
                  <IconButton style={style.menuButton} onClick={handleChangeRequestNavDrawer}>
                    <Menu color={white} />
                  </IconButton>
              }
              iconElementRight={
                <div style={style.iconsRightContainer}>
                  <TopMenuControl />
                </div>
              }
            />
          </div>
      );
  }
}

Header.propTypes = {
  styles: PropTypes.object,
  handleChangeRequestNavDrawer: PropTypes.func
};

function mapStateToProps(state, ownProps){
  var props = {
    user: {
      isAuthenticating: state.user.isAuthenticating,
      isAuthenticated: state.user.isAuthenticated,
      authError: state.user.authError,
      currentUser: state.user.currentUser
    },

    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code
  };
  return props;
}

export default connect(mapStateToProps, {logOut})(Header);



// WEBPACK FOOTER //
// ./src/containers/layout/Header.js